<template>
  <div :class="['receive-popup', showPopup ? 'active' : '']">
    <div class="popup fx-center">
      <div class="wrapper">
        <div class="content" v-if="popupConfig">
          <div class="title">{{popupConfig.title}}</div>
          <div class="desc">
            <div v-for="(item, index) of popupConfig.desc" :key="index">{{item}}</div>
          </div>
          <div class="icon">
            <div :class="popupConfig.icon"></div>
          </div>
          <div v-if="popupConfig.btnTxt" class="btn" @click="onTapBtn">{{popupConfig.btnTxt}}</div>
        </div>
        <div class="close-popup" @click="onTapClosePopup">
          <div class="close-icon"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const PopupConfigs = {
  0: {
    title: "恭喜您",
    desc: ["成功领取高铁管家黄金会员权益"],
    icon: "prize",
    btnTxt: "使用会员权益"
  },
  1: {
    title: "通知",
    desc: ["亲爱的，您已领取过该权益，", "续费可享受更多权益哦~"],
    icon: "notice",
    btnTxt: "续费"
  },
  2: {
    title: "通知",
    desc: ["哇！您当前已经是黄金会员了哦~", "最高享有黄金会员所有专属权益！"],
    icon: "notice",
    btnTxt: "使用会员权益"
  }
};

export default {
  props: ["showPopup", "popupConfigCode", "defPopupConfig"],
  computed: {
    popupConfig() {
      let config = null;
      if (this.defPopupConfig) {
        config = this.defPopupConfig;
      } else if (
        this.popupConfigCode == 0 ||
        this.popupConfigCode == 1 ||
        this.popupConfigCode == 2
      ) {
        config = PopupConfigs[this.popupConfigCode];
      }
      return config;
    }
  },
  methods: {
    onTapClosePopup() {
      this.$emit("close-popup");
    },
    onTapBtn() {
      this.$emit("use-vip");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../scss/_vars.scss";

.receive-popup {
  &.active .popup {
    background-color: rgba(0, 0, 0, 0.4);
    pointer-events: inherit;
    opacity: 1;
  }
  &.active .wrapper {
    transform: scale(1);
  }
}

.popup {
  pointer-events: none;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
  opacity: 0;
  will-change: opacity;
  transition: 0.3s opacity;
  max-width: 375 * $px;
  margin: 0 auto;
  width: 100%;
}

.wrapper {
  background-color: transparent;
  border-radius: 3 * $px;
  transform: scale(0.75);
  will-change: transform;
  transition: 0.3s transform;
  position: relative;
  z-index: 1002;
  .content {
    background: rgba(255, 255, 255, 1);
    border-radius: 8 * $px;
    width: 315 * $px;
    margin: 0 auto;
    position: relative;
    text-align: center;
    padding-top: 28 * $px;
    .title {
      font-size: 24 * $px;
      font-weight: 600;
      color: rgba(0, 0, 0, 1);
      margin-bottom: 11 * $px;
    }
    .desc {
      font-size: 16 * $px;
      color: rgba(0, 0, 0, 1);
      line-height: 28 * $px;
    }
    .icon {
      padding-bottom: 30 * $px;
      .prize {
        background: url("https://cdn.133.cn/gtgj/web/receiveVip/prize.png")
          no-repeat center;
        background-size: 100% 100%;
        width: 241 * $px;
        height: 112 * $px;
        margin: 30 * $px auto 0;
      }
      .notice {
        background: url("https://cdn.133.cn/gtgj/web/receiveVip/notice.png")
          no-repeat center;
        background-size: 100% 100%;
        width: 79 * $px;
        height: 79 * $px;
        margin: 40 * $px auto 10 * $px;
      }
    }
    .btn {
      height: 50 * $px;
      line-height: 50 * $px;
      background: linear-gradient(
        44deg,
        rgba(246, 123, 7, 1) 0%,
        rgba(250, 31, 32, 1) 100%
      );
      text-align: center;
      font-size: 18 * $px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      border-bottom-left-radius: 8 * $px;
      border-bottom-right-radius: 8 * $px;
    }
  }
  .close-popup {
    position: absolute;
    left: 40%;
    width: 20%;
    bottom: -60 * $px;
    .close-icon {
      background: url("https://cdn.133.cn/gtgj/web/receiveVip/close-icon.png")
        no-repeat center;
      background-size: 100% 100%;
      width: 36 * $px;
      height: 36 * $px;
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/vipCard/pages/receiveFree/components/popup.vue